module.exports = __webpack_public_path__ + "img/696347_98B0A2_28261E_362B22-256px.6cb6b3c1.png";